import { DialogModule } from '@angular/cdk/dialog';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
    exports: [MatIconModule, DialogModule, MatProgressSpinnerModule, MatButtonModule, MatDialogModule],
})
export class TermsOfUseMaterialModule {}
